(function () {
  window.nacktEditorial = window.nacktEditorial || {};
  var LINKED_COLOURWAY_SCROLL_KEY = "nackt-linked-colourway-scroll";
  var LINKED_COLOURWAY_MEDIA_KEY = "nackt-linked-colourway-media";
  var SIZE_SYSTEM_STORAGE_KEY = "nackt-size-system";
  var SIZE_CHART_SYSTEM_STORAGE_KEY = "nackt-size-chart-system";
  var SIZE_SYSTEMS = ["eu", "uk", "us_m", "us_w"];
  var SIZE_CHART_SYSTEMS = ["uk", "us_w", "us_m"];
  var SIZE_CHART_MEASUREMENTS = ["foot_length", "internal_width"];
  var SIZE_SYSTEM_LABELS = {
    eu: "EU",
    uk: "UK",
    us_m: "US M",
    us_w: "US W"
  };
  var SIZE_CHART_MEASUREMENT_LABELS = {
    foot_length: "Foot length (mm)",
    internal_width: "Internal width (mm)"
  };
  var SIZE_SYSTEM_ATTRIBUTES = {
    eu: "data-nackt-size-eu",
    uk: "data-nackt-size-uk",
    us_m: "data-nackt-size-us-m",
    us_w: "data-nackt-size-us-w"
  };
  var LINKED_COLOURWAY_SCROLL_TTL = 30000;
  var linkedColourwayDocumentCache = new Map();
  var linkedColourwaySwapController = null;
  var linkedColourwaySwapNonce = 0;
  var formsTeaserDocumentObserver = null;
  var formsTeaserRootObserver = null;
  var formsTeaserObservedRoot = null;
  var formsTeaserScheduledSync = null;
  var formsTeaserFrameSync = null;
  var formsTeaserPolling = null;
  var formsTeaserRootStyleState = null;
  var formsTeaserButtonStyleState = null;
  var formsPopupContainerElement = null;
  var formsPopupContainerStyleState = null;
  var formsPopupPanelElement = null;
  var formsPopupPanelStyleState = null;
  var formsPopupImageElement = null;
  var formsPopupImageStyleState = null;
  var formsPopupCloseWrapperElement = null;
  var formsPopupCloseWrapperStyleState = null;
  var desktopPdpPinFrame = null;
  var desktopPdpPinResizeObserver = null;
  var desktopPdpPinObservedSummary = null;
  var mobileContextualImageFrame = null;
  var mobileContextualImageResizeObserver = null;
  var mobileContextualImageObservedElements = [];
  var restockRocketPlacementObserver = null;
  var restockRocketPlacementFrame = null;
  var restockRocketRefreshTimer = null;
  var restockRocketRefreshVariantId = null;
  var restockRocketRefreshAttempts = 0;
  var restockRocketRefreshDelays = [80, 240, 560, 1100, 2000, 4000, 8000];

  initializeFormsTeaserObserver();

  function getStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function getPersistentStorage() {
    try {
      return window.localStorage;
    } catch (error) {
      return null;
    }
  }

  function getCurrentProductRoot() {
    return document.querySelector(".nackt-product-page[data-product-root]");
  }

  function getCurrentProductPath() {
    var productRoot = getCurrentProductRoot();

    if (!productRoot) {
      return window.location.pathname;
    }

    return productRoot.getAttribute("data-product-url-path") || window.location.pathname;
  }

  function getCurrentSelectedOptions() {
    var productRoot = getCurrentProductRoot();

    if (!productRoot) {
      return {
        option1: null,
        option2: null,
        option3: null
      };
    }

    return {
      option1: productRoot.getAttribute("data-current-option1") || null,
      option2: productRoot.getAttribute("data-current-option2") || null,
      option3: productRoot.getAttribute("data-current-option3") || null
    };
  }

  function getCurrentProductOptionNames() {
    var productRoot = getCurrentProductRoot();
    var rawOptionNames;

    if (!productRoot) {
      return [];
    }

    rawOptionNames = productRoot.getAttribute("data-product-option-names");

    if (!rawOptionNames) {
      return [];
    }

    try {
      return JSON.parse(rawOptionNames);
    } catch (error) {
      return [];
    }
  }

  function getSizeOptionIndex(optionNames) {
    var normalizedOptionNames = Array.isArray(optionNames) ? optionNames : [];

    return normalizedOptionNames.findIndex(function (optionName) {
      return typeof optionName === "string" && optionName.toLowerCase().indexOf("size") !== -1;
    });
  }

  function normalizeSizeSystem(sizeSystem) {
    if (SIZE_SYSTEMS.indexOf(sizeSystem) === -1) {
      return null;
    }

    return sizeSystem;
  }

  function getPreferredSizeSystem(defaultSizeSystem) {
    var storage = getPersistentStorage();
    var savedSizeSystem = storage ? storage.getItem(SIZE_SYSTEM_STORAGE_KEY) : null;

    return normalizeSizeSystem(savedSizeSystem)
      || normalizeSizeSystem(defaultSizeSystem)
      || "eu";
  }

  function savePreferredSizeSystem(sizeSystem) {
    var normalizedSizeSystem = normalizeSizeSystem(sizeSystem);
    var storage = getPersistentStorage();

    if (!normalizedSizeSystem || !storage) {
      return;
    }

    try {
      storage.setItem(SIZE_SYSTEM_STORAGE_KEY, normalizedSizeSystem);
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function getSizeLabel(labelEl, sizeSystem) {
    var attributeName = SIZE_SYSTEM_ATTRIBUTES[sizeSystem] || SIZE_SYSTEM_ATTRIBUTES.eu;
    var fallbackAttributeName = SIZE_SYSTEM_ATTRIBUTES.eu;

    if (!labelEl) {
      return "";
    }

    return labelEl.getAttribute(attributeName)
      || labelEl.getAttribute(fallbackAttributeName)
      || labelEl.textContent.trim();
  }

  function getSizePickerSelectedLabelEl(sizePicker) {
    var checkedInput = sizePicker.querySelector("input[data-single-option-selector]:checked");
    var selectedContainer;

    if (!checkedInput) {
      return null;
    }

    selectedContainer = checkedInput.closest(".label-only-input");

    return selectedContainer ? selectedContainer.querySelector("[data-nackt-size-label]") : null;
  }

  function updateStickyPurchaseSizeLabel(sizePicker) {
    var productRoot = sizePicker.closest("[data-product-root]") || document;
    var currentLabel = sizePicker.querySelector("[data-nackt-selected-size-label]");
    var stickyLabel = productRoot.querySelector("[data-nackt-sticky-selected-size]");
    var fallbackLabel;

    if (!stickyLabel) {
      return;
    }

    fallbackLabel = stickyLabel.getAttribute("data-nackt-sticky-size-fallback") || "";

    if (!currentLabel || !currentLabel.textContent.trim()) {
      stickyLabel.textContent = fallbackLabel;
      return;
    }

    stickyLabel.innerHTML = currentLabel.innerHTML;
  }

  function updateSizePickerCurrentLabel(sizePicker, sizeSystem) {
    var currentLabel = sizePicker.querySelector("[data-nackt-selected-size-label]");
    var selectedLabelEl = getSizePickerSelectedLabelEl(sizePicker);
    var normalizedSizeSystem = normalizeSizeSystem(sizeSystem) || "eu";
    var euSizeLabel;
    var convertedSizeLabel;
    var trueSizeSpan;
    var convertedSizeSpan;

    if (!currentLabel || !selectedLabelEl) {
      return;
    }

    euSizeLabel = getSizeLabel(selectedLabelEl, "eu");
    convertedSizeLabel = getSizeLabel(selectedLabelEl, normalizedSizeSystem);
    trueSizeSpan = document.createElement("span");
    trueSizeSpan.className = "nackt-size-system-current__true-size";
    trueSizeSpan.textContent = [SIZE_SYSTEM_LABELS.eu, euSizeLabel].join(" ");

    currentLabel.textContent = "";
    currentLabel.appendChild(trueSizeSpan);

    if (normalizedSizeSystem === "eu" || !convertedSizeLabel || convertedSizeLabel === euSizeLabel) {
      updateStickyPurchaseSizeLabel(sizePicker);
      return;
    }

    convertedSizeSpan = document.createElement("span");
    convertedSizeSpan.className = "nackt-size-system-current__converted-size";
    convertedSizeSpan.textContent = " (" + [SIZE_SYSTEM_LABELS[normalizedSizeSystem], convertedSizeLabel].join(" ") + ")";
    currentLabel.appendChild(convertedSizeSpan);
    updateStickyPurchaseSizeLabel(sizePicker);
  }

  function updateSizePicker(sizePicker, sizeSystem) {
    var normalizedSizeSystem = normalizeSizeSystem(sizeSystem) || "eu";

    sizePicker.setAttribute("data-nackt-size-system", normalizedSizeSystem);

    sizePicker.querySelectorAll("[data-nackt-size-label]").forEach(function (labelEl) {
      labelEl.textContent = getSizeLabel(labelEl, normalizedSizeSystem);
    });

    sizePicker.querySelectorAll("[data-nackt-size-system-button]").forEach(function (button) {
      var isActive = button.getAttribute("data-nackt-size-system-button") === normalizedSizeSystem;
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    updateSizePickerCurrentLabel(sizePicker, normalizedSizeSystem);
  }

  function updateAllSizePickers(sizeSystem, root) {
    var scope = root || document;
    var normalizedSizeSystem = normalizeSizeSystem(sizeSystem) || "eu";

    scope.querySelectorAll("[data-nackt-size-picker]").forEach(function (sizePicker) {
      updateSizePicker(sizePicker, normalizedSizeSystem);
    });
  }

  function initializeSizeSystemPicker(sizePicker) {
    var defaultSizeSystem = sizePicker.getAttribute("data-nackt-size-default-system");
    var preferredSizeSystem = getPreferredSizeSystem(defaultSizeSystem);

    if (sizePicker.getAttribute("data-nackt-size-picker-initialized") !== "true") {
      sizePicker.setAttribute("data-nackt-size-picker-initialized", "true");

      sizePicker.addEventListener("click", function (event) {
        var button = event.target.closest("[data-nackt-size-system-button]");
        var requestedSizeSystem;

        if (!button || !sizePicker.contains(button)) {
          return;
        }

        requestedSizeSystem = normalizeSizeSystem(button.getAttribute("data-nackt-size-system-button"));

        if (!requestedSizeSystem) {
          return;
        }

        savePreferredSizeSystem(requestedSizeSystem);
        updateAllSizePickers(requestedSizeSystem);
      });

      sizePicker.addEventListener("change", function () {
        updateSizePickerCurrentLabel(
          sizePicker,
          normalizeSizeSystem(sizePicker.getAttribute("data-nackt-size-system")) || preferredSizeSystem
        );
      });
    }

    updateSizePicker(sizePicker, preferredSizeSystem);
  }

  function initializeSizeSystemPickers(root) {
    var scope = root || document;

    scope.querySelectorAll("[data-nackt-size-picker]").forEach(initializeSizeSystemPicker);
  }

  function normalizeSizeChartSystem(sizeSystem) {
    return SIZE_CHART_SYSTEMS.indexOf(sizeSystem) === -1 ? null : sizeSystem;
  }

  function getPreferredSizeChartSystem() {
    var storage = getPersistentStorage();
    var savedSizeSystem = storage ? storage.getItem(SIZE_CHART_SYSTEM_STORAGE_KEY) : null;
    var sizePicker = document.querySelector("[data-nackt-size-picker]");
    var currentSizeSystem = sizePicker
      ? sizePicker.getAttribute("data-nackt-size-system")
      : null;

    return normalizeSizeChartSystem(savedSizeSystem)
      || normalizeSizeChartSystem(currentSizeSystem)
      || "uk";
  }

  function savePreferredSizeChartSystem(sizeSystem) {
    var normalizedSizeSystem = normalizeSizeChartSystem(sizeSystem);
    var storage = getPersistentStorage();

    if (!normalizedSizeSystem || !storage) {
      return;
    }

    try {
      storage.setItem(SIZE_CHART_SYSTEM_STORAGE_KEY, normalizedSizeSystem);
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function normalizeSizeChartHeading(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  }

  function getSizeChartConversionColumns(headerRow) {
    var columns = {};

    Array.from(headerRow.cells).forEach(function (cell, index) {
      var heading = normalizeSizeChartHeading(cell.textContent);

      if (heading === "uk") {
        columns.uk = index;
      } else if (heading === "usm" || heading === "usmen") {
        columns.us_m = index;
      } else if (heading === "usw" || heading === "uswomen") {
        columns.us_w = index;
      } else if (heading === "footlength" || heading === "footlengthmm") {
        columns.foot_length = index;
      } else if (heading === "internalwidth" || heading === "internalwidthmm") {
        columns.internal_width = index;
      }
    });

    return columns;
  }

  function initializeDynamicSizeChart(root) {
    var table = root ? root.querySelector("table") : null;
    var rows;
    var headerRow;
    var columns;
    var conversionValues;
    var conversionCellIndex;
    var measurementValues;
    var measurementCellIndex;
    var hasMeasurementColumns;
    var select;
    var measurementSelect;
    var preferredSizeSystem;
    var tableWrapper;

    if (!table || table.getAttribute("data-nackt-dynamic-size-chart") === "true") {
      return;
    }

    rows = Array.from(table.rows);
    headerRow = rows[0];

    if (!headerRow) {
      return;
    }

    columns = getSizeChartConversionColumns(headerRow);

    if (
      columns.uk === undefined
      || columns.us_m === undefined
      || columns.us_w === undefined
    ) {
      return;
    }

    conversionCellIndex = columns.uk;
    measurementCellIndex = columns.foot_length;
    hasMeasurementColumns = (
      columns.foot_length !== undefined
      && columns.internal_width !== undefined
    );
    conversionValues = rows.map(function (row) {
      return {
        uk: row.cells[columns.uk] ? row.cells[columns.uk].textContent.trim() : "",
        us_m: row.cells[columns.us_m] ? row.cells[columns.us_m].textContent.trim() : "",
        us_w: row.cells[columns.us_w] ? row.cells[columns.us_w].textContent.trim() : ""
      };
    });
    measurementValues = hasMeasurementColumns
      ? rows.map(function (row) {
          return {
            foot_length: row.cells[columns.foot_length]
              ? row.cells[columns.foot_length].textContent.trim()
              : "",
            internal_width: row.cells[columns.internal_width]
              ? row.cells[columns.internal_width].textContent.trim()
              : ""
          };
        })
      : [];

    rows.forEach(function (row) {
      if (row.cells[columns.us_m]) {
        row.cells[columns.us_m].hidden = true;
      }

      if (row.cells[columns.us_w]) {
        row.cells[columns.us_w].hidden = true;
      }

      if (row.cells[conversionCellIndex]) {
        row.cells[conversionCellIndex].classList.add("nackt-size-chart-conversion-cell");
      }
    });

    select = document.createElement("select");
    select.className = "nackt-size-chart-system-select";
    select.setAttribute("aria-label", "Size conversion system");

    SIZE_CHART_SYSTEMS.forEach(function (sizeSystem) {
      var option = document.createElement("option");
      option.value = sizeSystem;
      option.textContent = SIZE_SYSTEM_LABELS[sizeSystem];
      select.appendChild(option);
    });

    function updateConversionColumn(sizeSystem) {
      var normalizedSizeSystem = normalizeSizeChartSystem(sizeSystem) || "uk";

      rows.slice(1).forEach(function (row, rowIndex) {
        var targetCell = row.cells[conversionCellIndex];
        var rowValues = conversionValues[rowIndex + 1];

        if (targetCell && rowValues) {
          targetCell.textContent = rowValues[normalizedSizeSystem];
        }
      });

      select.value = normalizedSizeSystem;
      headerRow.cells[conversionCellIndex].setAttribute(
        "data-nackt-size-chart-system-label",
        SIZE_SYSTEM_LABELS[normalizedSizeSystem]
      );
      table.setAttribute("data-nackt-size-chart-system", normalizedSizeSystem);
    }

    select.addEventListener("change", function () {
      savePreferredSizeChartSystem(select.value);
      updateConversionColumn(select.value);
    });

    headerRow.cells[conversionCellIndex].textContent = "";
    headerRow.cells[conversionCellIndex].classList.add("nackt-size-chart-conversion-header");
    headerRow.cells[conversionCellIndex].appendChild(select);

    if (hasMeasurementColumns) {
      var measurementHeaderCell = headerRow.cells[measurementCellIndex];
      var measurementDesktopLabel = document.createElement("span");

      rows.forEach(function (row, rowIndex) {
        var targetCell = row.cells[measurementCellIndex];
        var alternateCell = row.cells[columns.internal_width];
        var footLengthValue;
        var internalWidthValue;

        if (alternateCell) {
          alternateCell.classList.add("nackt-size-chart-mobile-alternate-column");
        }

        if (rowIndex === 0 || !targetCell) {
          return;
        }

        footLengthValue = document.createElement("span");
        footLengthValue.className = "nackt-size-chart-measurement-value nackt-size-chart-measurement-value--foot-length";
        footLengthValue.textContent = measurementValues[rowIndex].foot_length;

        internalWidthValue = document.createElement("span");
        internalWidthValue.className = "nackt-size-chart-measurement-value nackt-size-chart-measurement-value--internal-width";
        internalWidthValue.textContent = measurementValues[rowIndex].internal_width;

        targetCell.textContent = "";
        targetCell.appendChild(footLengthValue);
        targetCell.appendChild(internalWidthValue);
      });

      measurementSelect = document.createElement("select");
      measurementSelect.className = "nackt-size-chart-measurement-select";
      measurementSelect.setAttribute("aria-label", "Size measurement");

      SIZE_CHART_MEASUREMENTS.forEach(function (measurement) {
        var option = document.createElement("option");
        option.value = measurement;
        option.textContent = SIZE_CHART_MEASUREMENT_LABELS[measurement];
        measurementSelect.appendChild(option);
      });

      measurementDesktopLabel.className = "nackt-size-chart-measurement-desktop-label";

      while (measurementHeaderCell.firstChild) {
        measurementDesktopLabel.appendChild(measurementHeaderCell.firstChild);
      }

      measurementHeaderCell.classList.add("nackt-size-chart-measurement-header");
      measurementHeaderCell.appendChild(measurementDesktopLabel);
      measurementHeaderCell.appendChild(measurementSelect);
      table.setAttribute("data-nackt-size-chart-measurement", "foot_length");
      measurementSelect.value = "foot_length";

      measurementSelect.addEventListener("change", function () {
        table.setAttribute("data-nackt-size-chart-measurement", measurementSelect.value);
      });
    }

    table.classList.add("nackt-dynamic-size-chart");
    table.setAttribute("data-nackt-dynamic-size-chart", "true");
    tableWrapper = table.closest(".rte__table");

    if (tableWrapper) {
      tableWrapper.classList.add("nackt-dynamic-size-chart-wrapper");
    }

    preferredSizeSystem = getPreferredSizeChartSystem();
    updateConversionColumn(preferredSizeSystem);
  }

  window.nacktEditorial.initializeDynamicSizeChart = initializeDynamicSizeChart;

  function saveLinkedColourwayScroll(targetHref) {
    var storage = getStorage();
    var currentPath = getCurrentProductPath();
    var targetUrl;

    if (!storage || !targetHref || window.scrollY <= 0) {
      return;
    }

    try {
      targetUrl = new URL(targetHref, window.location.origin);
    } catch (error) {
      return;
    }

    if (targetUrl.pathname === currentPath) {
      return;
    }

    try {
      storage.setItem(
        LINKED_COLOURWAY_SCROLL_KEY,
        JSON.stringify({
          scrollY: window.scrollY,
          targetPath: targetUrl.pathname,
          sourcePath: currentPath,
          timestamp: Date.now()
        })
      );
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function getCurrentLinkedColourwayMediaIndex() {
    var productRoot = document.querySelector(".nackt-product-page[data-linked-colourway-media-index]");
    var rawIndex;
    var parsedIndex;

    if (!productRoot) {
      return 0;
    }

    rawIndex = productRoot.getAttribute("data-linked-colourway-media-index");
    parsedIndex = parseInt(rawIndex, 10);

    if (Number.isNaN(parsedIndex) || parsedIndex < 0) {
      return 0;
    }

    return parsedIndex;
  }

  function saveLinkedColourwayMedia(targetHref) {
    var storage = getStorage();
    var currentPath = getCurrentProductPath();
    var targetUrl;

    if (!storage || !targetHref) {
      return;
    }

    try {
      targetUrl = new URL(targetHref, window.location.origin);
    } catch (error) {
      return;
    }

    if (targetUrl.pathname === currentPath) {
      return;
    }

    try {
      storage.setItem(
        LINKED_COLOURWAY_MEDIA_KEY,
        JSON.stringify({
          mediaIndex: getCurrentLinkedColourwayMediaIndex(),
          targetPath: targetUrl.pathname,
          sourcePath: currentPath,
          timestamp: Date.now()
        })
      );
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function restoreLinkedColourwayScroll() {
    var storage = getStorage();
    var rawValue;
    var payload;

    if (!storage || !document.querySelector(".nackt-product-page")) {
      return;
    }

    rawValue = storage.getItem(LINKED_COLOURWAY_SCROLL_KEY);

    if (!rawValue) {
      return;
    }

    try {
      payload = JSON.parse(rawValue);
    } catch (error) {
      storage.removeItem(LINKED_COLOURWAY_SCROLL_KEY);
      return;
    }

    if (
      !payload
      || payload.targetPath !== window.location.pathname
      || typeof payload.scrollY !== "number"
      || Date.now() - payload.timestamp > LINKED_COLOURWAY_SCROLL_TTL
    ) {
      storage.removeItem(LINKED_COLOURWAY_SCROLL_KEY);
      return;
    }

    storage.removeItem(LINKED_COLOURWAY_SCROLL_KEY);

    if (window.history && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    window.scrollTo(0, payload.scrollY);
    window.requestAnimationFrame(function () {
      window.scrollTo(0, payload.scrollY);
    });
  }

  function clearLinkedColourwayScroll() {
    var storage = getStorage();

    if (!storage) {
      return;
    }

    storage.removeItem(LINKED_COLOURWAY_SCROLL_KEY);
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia("(max-width: 1023px)").matches;
  }

  function getHeaderOffset() {
    var stickyHeader = document.querySelector("[data-theme-header]");
    var stickyHeaderSection = stickyHeader ? stickyHeader.closest(".shopify-section") : null;
    var brandTicker = document.querySelector(".nackt-brand-ticker");
    var brandTickerSection = brandTicker ? brandTicker.closest(".shopify-section-group-header-group") : null;
    var computedDocument = window.getComputedStyle(document.documentElement);
    var computedBody = window.getComputedStyle(document.body);
    var stickyHeaderHeight = parseFloat(computedDocument.getPropertyValue("--sticky-header-height"))
      || parseFloat(computedBody.getPropertyValue("--sticky-header-height"))
      || 0;
    var offset = stickyHeaderHeight;
    var stickyHeaderRect;
    var brandTickerRect;

    if (stickyHeaderSection) {
      stickyHeaderRect = stickyHeaderSection.getBoundingClientRect();

      if (stickyHeaderRect.bottom > 0) {
        offset = Math.max(offset, stickyHeaderRect.bottom);
      }
    }

    if (brandTickerSection) {
      brandTickerRect = brandTickerSection.getBoundingClientRect();

      if (brandTickerRect.bottom > 0) {
        offset = Math.max(offset, brandTickerRect.bottom);
      }
    }

    return offset;
  }

  function getElementOuterHeight(element) {
    var rect;
    var styles;

    if (!element) {
      return 0;
    }

    rect = element.getBoundingClientRect();
    styles = window.getComputedStyle(element);

    return rect.height
      + (parseFloat(styles.marginTop) || 0)
      + (parseFloat(styles.marginBottom) || 0);
  }

  function getStableMobileHeaderHeight(stickyHeaderSection, brandTickerSection) {
    var computedDocument = window.getComputedStyle(document.documentElement);
    var headerGroupHeight = parseFloat(
      computedDocument.getPropertyValue("--header-group-height")
    );

    if (headerGroupHeight > 0) {
      return headerGroupHeight;
    }

    return getElementOuterHeight(stickyHeaderSection)
      + getElementOuterHeight(brandTickerSection);
  }

  function observeMobileContextualImageLayout(elements) {
    var observedElements = elements.filter(Boolean);
    var observationsMatch = observedElements.length === mobileContextualImageObservedElements.length
      && observedElements.every(function (element, index) {
        return element === mobileContextualImageObservedElements[index];
      });

    if (!window.ResizeObserver || observationsMatch) {
      return;
    }

    if (!mobileContextualImageResizeObserver) {
      mobileContextualImageResizeObserver = new window.ResizeObserver(function () {
        scheduleMobileContextualImageSync();
      });
    } else {
      mobileContextualImageResizeObserver.disconnect();
    }

    mobileContextualImageObservedElements = observedElements;
    observedElements.forEach(function (element) {
      mobileContextualImageResizeObserver.observe(element);
    });
  }

  function clearMobileContextualImageHeight(productRoot) {
    var root = productRoot || getCurrentProductRoot();

    if (root) {
      root.style.removeProperty("--nackt-mobile-contextual-image-height");
    }
  }

  function syncMobileContextualImageHeight() {
    var productRoot = getCurrentProductRoot();
    var contextualImage;
    var stickyTray;
    var titleBlock;
    var content;
    var mediaContainer;
    var mediaIndicator;
    var stickyHeader;
    var stickyHeaderSection;
    var brandTicker;
    var brandTickerSection;
    var viewport = window.visualViewport;
    var viewportHeight;
    var headerHeight;
    var trayHeight;
    var contentRect;
    var titleRect;
    var titleHeight;
    var mediaContainerStyles;
    var mediaChromeHeight;
    var imageHeight;

    mobileContextualImageFrame = null;

    if (!productRoot || !isMobileViewport()) {
      clearMobileContextualImageHeight(productRoot);
      return;
    }

    contextualImage = productRoot.querySelector('[data-nackt-contextual-product-image="true"]');
    stickyTray = productRoot.querySelector(".nackt-mobile-sticky-purchase-tray");
    titleBlock = productRoot.querySelector(".nackt-product-form__block--title");
    content = productRoot.querySelector(".nackt-product-page__content");
    mediaContainer = productRoot.querySelector(".nackt-product-page__media");
    mediaIndicator = productRoot.querySelector(".nackt-product-media-indicator");

    if (!contextualImage || !stickyTray || !titleBlock || !content || !mediaContainer) {
      clearMobileContextualImageHeight(productRoot);
      return;
    }

    stickyHeader = document.querySelector("[data-theme-header]");
    stickyHeaderSection = stickyHeader ? stickyHeader.closest(".shopify-section") : null;
    brandTicker = document.querySelector(".nackt-brand-ticker");
    brandTickerSection = brandTicker ? brandTicker.closest(".shopify-section-group-header-group") : null;

    observeMobileContextualImageLayout([
      stickyHeaderSection,
      brandTickerSection,
      stickyTray,
      titleBlock,
      mediaIndicator
    ]);

    viewportHeight = viewport && viewport.height ? viewport.height : window.innerHeight;
    headerHeight = getStableMobileHeaderHeight(stickyHeaderSection, brandTickerSection);
    trayHeight = stickyTray.getBoundingClientRect().height;
    contentRect = content.getBoundingClientRect();
    titleRect = titleBlock.getBoundingClientRect();
    titleHeight = Math.max(0, titleRect.bottom - contentRect.top);
    mediaContainerStyles = window.getComputedStyle(mediaContainer);
    mediaChromeHeight = getElementOuterHeight(mediaIndicator)
      + (parseFloat(mediaContainerStyles.paddingTop) || 0)
      + (parseFloat(mediaContainerStyles.paddingBottom) || 0)
      + (parseFloat(mediaContainerStyles.borderTopWidth) || 0)
      + (parseFloat(mediaContainerStyles.borderBottomWidth) || 0);
    imageHeight = Math.max(
      1,
      Math.floor(viewportHeight - headerHeight - trayHeight - titleHeight - mediaChromeHeight)
    );

    if (
      productRoot.style.getPropertyValue("--nackt-mobile-contextual-image-height")
      !== imageHeight + "px"
    ) {
      productRoot.style.setProperty("--nackt-mobile-contextual-image-height", imageHeight + "px");
    }
  }

  function scheduleMobileContextualImageSync() {
    if (mobileContextualImageFrame) {
      return;
    }

    mobileContextualImageFrame = window.requestAnimationFrame(syncMobileContextualImageHeight);
  }

  function clearDesktopPdpPin(productRoot) {
    var root = productRoot || getCurrentProductRoot();

    if (!root) {
      return;
    }

    root.removeAttribute("data-desktop-pdp-pin");
    root.style.removeProperty("--nackt-pdp-summary-height");
    root.style.removeProperty("--nackt-pdp-form-left");
    root.style.removeProperty("--nackt-pdp-form-width");
  }

  function observeDesktopPdpSummary(summary) {
    if (!window.ResizeObserver) {
      return;
    }

    if (desktopPdpPinObservedSummary === summary) {
      return;
    }

    if (desktopPdpPinResizeObserver) {
      desktopPdpPinResizeObserver.disconnect();
    }

    desktopPdpPinObservedSummary = summary;
    desktopPdpPinResizeObserver = new window.ResizeObserver(function () {
      scheduleDesktopPdpPinSync();
    });
    desktopPdpPinResizeObserver.observe(summary);
  }

  function syncDesktopPdpPin() {
    var productRoot = getCurrentProductRoot();
    var summary;
    var formSurface;
    var summaryRect;
    var formSurfaceRect;
    var formWrapper;
    var formWrapperStyles;
    var formWrapperPaddingTop;
    var formWrapperPaddingBottom;
    var pinnedSurfaceHeight;
    var content;
    var contentRect;
    var contentStyles;
    var contentPaddingLeft;
    var contentPaddingRight;
    var contentBorderLeft;
    var contentBorderRight;
    var pinLeft;
    var pinWidth;
    var rootRect;
    var headerOffset;
    var pinState;

    desktopPdpPinFrame = null;

    if (!productRoot || isMobileViewport()) {
      clearDesktopPdpPin(productRoot);
      return;
    }

    summary = productRoot.querySelector(".nackt-product-form__sticky-summary");

    if (!summary) {
      clearDesktopPdpPin(productRoot);
      return;
    }

    formSurface = productRoot.querySelector(".nackt-product-form") || summary;
    observeDesktopPdpSummary(formSurface);
    formWrapper = productRoot.querySelector(".nackt-product-page__form");
    content = productRoot.querySelector(".nackt-product-page__content");
    summaryRect = summary.getBoundingClientRect();
    formSurfaceRect = formSurface.getBoundingClientRect();
    formWrapperStyles = formWrapper ? window.getComputedStyle(formWrapper) : null;
    formWrapperPaddingTop = formWrapperStyles ? parseFloat(formWrapperStyles.paddingTop) || 0 : 0;
    formWrapperPaddingBottom = formWrapperStyles ? parseFloat(formWrapperStyles.paddingBottom) || 0 : 0;
    pinnedSurfaceHeight = formSurfaceRect.height + formWrapperPaddingTop + formWrapperPaddingBottom;
    contentRect = content ? content.getBoundingClientRect() : null;
    rootRect = productRoot.getBoundingClientRect();
    headerOffset = getHeaderOffset();

    productRoot.style.setProperty("--nackt-pdp-pin-top", headerOffset + "px");
    productRoot.style.setProperty("--nackt-pdp-summary-height", Math.ceil(summaryRect.height) + "px");

    if (contentRect) {
      contentStyles = window.getComputedStyle(content);
      contentPaddingLeft = parseFloat(contentStyles.paddingLeft) || 0;
      contentPaddingRight = parseFloat(contentStyles.paddingRight) || 0;
      contentBorderLeft = parseFloat(contentStyles.borderLeftWidth) || 0;
      contentBorderRight = parseFloat(contentStyles.borderRightWidth) || 0;
      pinLeft = contentRect.left + contentBorderLeft + contentPaddingLeft;
      pinWidth = contentRect.width - contentBorderLeft - contentBorderRight - contentPaddingLeft - contentPaddingRight;

      productRoot.style.setProperty("--nackt-pdp-form-left", pinLeft + "px");
      productRoot.style.setProperty("--nackt-pdp-form-width", Math.max(0, pinWidth) + "px");
    }

    if (window.scrollY <= 0 || rootRect.top > headerOffset) {
      pinState = null;
    } else if (rootRect.bottom > headerOffset + pinnedSurfaceHeight) {
      pinState = "fixed";
    } else if (rootRect.bottom > 0) {
      pinState = "bottom";
    } else {
      pinState = null;
    }

    if (pinState) {
      productRoot.setAttribute("data-desktop-pdp-pin", pinState);
    } else {
      productRoot.removeAttribute("data-desktop-pdp-pin");
    }
  }

  function scheduleDesktopPdpPinSync() {
    if (desktopPdpPinFrame) {
      return;
    }

    desktopPdpPinFrame = window.requestAnimationFrame(syncDesktopPdpPin);
  }

  function getFormsRoot() {
    return findFormsRoot(document);
  }

  function findFormsRoot(rootNode) {
    var formsRoot;
    var elements;
    var index;
    var nestedFormsRoot;

    if (!rootNode || typeof rootNode.querySelector !== "function") {
      return null;
    }

    formsRoot = rootNode.querySelector("#app-embed[data-form-root='true']");

    if (formsRoot) {
      return formsRoot;
    }

    if (typeof rootNode.querySelectorAll !== "function") {
      return null;
    }

    elements = rootNode.querySelectorAll("*");

    for (index = 0; index < elements.length; index += 1) {
      if (!elements[index].shadowRoot) {
        continue;
      }

      nestedFormsRoot = findFormsRoot(elements[index].shadowRoot);

      if (nestedFormsRoot) {
        return nestedFormsRoot;
      }
    }

    return null;
  }

  function getFormsTeaserButton(root) {
    if (!root) {
      return null;
    }

    return root.querySelector(
      "button[aria-haspopup='dialog'][aria-label='Join the club'], ._teaserContainer_trejf_5"
    );
  }

  function setImportantStyle(element, property, value) {
    var currentValue;
    var currentPriority;

    if (!element) {
      return;
    }

    if (value === null || value === undefined || value === "") {
      if (!element.style.getPropertyValue(property)) {
        return;
      }

      element.style.removeProperty(property);
      return;
    }

    currentValue = element.style.getPropertyValue(property);
    currentPriority = element.style.getPropertyPriority(property);

    if (currentValue === value && currentPriority === "important") {
      return;
    }

    element.style.setProperty(property, value, "important");
  }

  function captureInlineStyleState(element, properties) {
    if (!element) {
      return [];
    }

    return properties.map(function (property) {
      return {
        property: property,
        value: element.style.getPropertyValue(property),
        priority: element.style.getPropertyPriority(property)
      };
    });
  }

  function restoreInlineStyleState(element, styleState) {
    if (!element || !styleState) {
      return;
    }

    styleState.forEach(function (entry) {
      if (entry.value) {
        element.style.setProperty(entry.property, entry.value, entry.priority);
      } else {
        element.style.removeProperty(entry.property);
      }
    });
  }

  function clearFormsPopupPresentation() {
    restoreInlineStyleState(formsPopupContainerElement, formsPopupContainerStyleState);

    if (formsPopupPanelElement) {
      restoreInlineStyleState(formsPopupPanelElement, formsPopupPanelStyleState);
    }

    if (formsPopupImageElement) {
      restoreInlineStyleState(formsPopupImageElement, formsPopupImageStyleState);
    }

    if (formsPopupCloseWrapperElement) {
      restoreInlineStyleState(
        formsPopupCloseWrapperElement,
        formsPopupCloseWrapperStyleState
      );
    }

    formsPopupContainerElement = null;
    formsPopupContainerStyleState = null;
    formsPopupPanelElement = null;
    formsPopupPanelStyleState = null;
    formsPopupImageElement = null;
    formsPopupImageStyleState = null;
    formsPopupCloseWrapperElement = null;
    formsPopupCloseWrapperStyleState = null;
  }

  function syncFormsPopupPresentation(root) {
    var closeButton;
    var panel;
    var popupContainer;
    var imageElement;
    var closeWrapper;
    var mobileViewport;

    if (
      !root
      || root.getAttribute("data-current-step") !== "form"
    ) {
      clearFormsPopupPresentation();
      return false;
    }

    closeButton = root.querySelector(
      "[role='button'][aria-label='Close modal'], button[aria-label='Close modal']"
    );
    panel = closeButton && closeButton.closest("section[role='dialog']");

    if (!panel) {
      clearFormsPopupPresentation();
      return false;
    }

    popupContainer = panel.closest("[class*='appEmbedRoot']");
    imageElement = panel.querySelector("[style*='background-image']");
    closeWrapper = closeButton.parentElement;
    mobileViewport = isMobileViewport();

    if (
      formsPopupContainerElement !== popupContainer
      || formsPopupPanelElement !== panel
      || formsPopupImageElement !== imageElement
      || formsPopupCloseWrapperElement !== closeWrapper
    ) {
      clearFormsPopupPresentation();
      formsPopupContainerElement = popupContainer;
      formsPopupContainerStyleState = captureInlineStyleState(popupContainer, [
        "position",
        "top",
        "right",
        "bottom",
        "left",
        "width",
        "max-width",
        "max-height",
        "transform",
        "z-index"
      ]);
      formsPopupPanelElement = panel;
      formsPopupPanelStyleState = captureInlineStyleState(panel, [
        "position",
        "top",
        "right",
        "bottom",
        "left",
        "width",
        "max-width",
        "max-height",
        "transform",
        "z-index",
        "overflow-x",
        "overflow-y",
        "overscroll-behavior-y",
        "-webkit-overflow-scrolling"
      ]);
      formsPopupImageElement = imageElement;
      formsPopupImageStyleState = captureInlineStyleState(imageElement, [
        "background-position"
      ]);
      formsPopupCloseWrapperElement = closeWrapper;
      formsPopupCloseWrapperStyleState = captureInlineStyleState(closeWrapper, [
        "position",
        "top",
        "right",
        "bottom",
        "left",
        "z-index"
      ]);
    }

    setImportantStyle(popupContainer, "z-index", "2147483646");

    if (!mobileViewport) {
      setImportantStyle(popupContainer, "position", "fixed");
      setImportantStyle(popupContainer, "top", "50%");
      setImportantStyle(popupContainer, "right", "auto");
      setImportantStyle(popupContainer, "bottom", "auto");
      setImportantStyle(popupContainer, "left", "50%");
      setImportantStyle(popupContainer, "width", "auto");
      setImportantStyle(popupContainer, "max-width", "calc(100vw - 48px)");
      setImportantStyle(popupContainer, "max-height", "calc(100dvh - 48px)");
      setImportantStyle(popupContainer, "transform", "translate(-50%, -50%)");

      setImportantStyle(panel, "width", "min(640px, calc(100vw - 98px))");
      setImportantStyle(panel, "max-width", "calc(100vw - 98px)");
      setImportantStyle(panel, "max-height", "calc(100dvh - 98px)");
      setImportantStyle(panel, "overflow-x", "hidden");
      setImportantStyle(panel, "overflow-y", "auto");
      setImportantStyle(panel, "overscroll-behavior-y", "contain");

      if (imageElement) {
        setImportantStyle(imageElement, "background-position", "center bottom");
      }

      return true;
    }

    setImportantStyle(panel, "position", "fixed");
    setImportantStyle(panel, "top", "max(12px, env(safe-area-inset-top, 0px))");
    setImportantStyle(panel, "right", "auto");
    setImportantStyle(panel, "bottom", "auto");
    setImportantStyle(panel, "left", "50%");
    setImportantStyle(panel, "width", "min(640px, calc(100vw - 24px))");
    setImportantStyle(panel, "max-width", "calc(100vw - 24px)");
    setImportantStyle(panel, "max-height", "calc(100dvh - 24px)");
    setImportantStyle(panel, "transform", "translateX(-50%)");
    setImportantStyle(panel, "z-index", "2147483646");
    setImportantStyle(panel, "overflow-x", "hidden");
    setImportantStyle(panel, "overflow-y", "auto");
    setImportantStyle(panel, "overscroll-behavior-y", "contain");
    setImportantStyle(panel, "-webkit-overflow-scrolling", "touch");

    if (imageElement) {
      setImportantStyle(imageElement, "background-position", "center bottom");
    }

    if (closeWrapper) {
      setImportantStyle(closeWrapper, "position", "fixed");
      setImportantStyle(closeWrapper, "top", "max(24px, calc(env(safe-area-inset-top, 0px) + 12px))");
      setImportantStyle(closeWrapper, "right", "24px");
      setImportantStyle(closeWrapper, "bottom", "auto");
      setImportantStyle(closeWrapper, "left", "auto");
      setImportantStyle(closeWrapper, "z-index", "2147483646");
    }

    return true;
  }

  function isElementVisible(element) {
    if (!element) {
      return false;
    }

    return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function clearFormsTeaserPosition(root) {
    var teaserButton;

    if (!root || root.getAttribute("data-nackt-forms-teaser-positioned") !== "true") {
      return;
    }

    teaserButton = getFormsTeaserButton(root);
    restoreInlineStyleState(root, formsTeaserRootStyleState);
    restoreInlineStyleState(teaserButton, formsTeaserButtonStyleState);

    formsTeaserRootStyleState = null;
    formsTeaserButtonStyleState = null;
    root.removeAttribute("data-nackt-forms-teaser-positioned");
  }

  function syncFormsTeaserPosition(root) {
    var teaserButton;
    var topOffset;

    if (!root) {
      clearFormsPopupPresentation();
      clearFormsTeaserPosition(root);
      return false;
    }

    if (root.getAttribute("data-current-step") === "form") {
      clearFormsTeaserPosition(root);
      return syncFormsPopupPresentation(root);
    }

    clearFormsPopupPresentation();

    if (root.getAttribute("data-current-step") !== "tease") {
      clearFormsTeaserPosition(root);
      return false;
    }

    teaserButton = getFormsTeaserButton(root);

    if (!teaserButton || !isElementVisible(teaserButton)) {
      clearFormsTeaserPosition(root);
      return false;
    }

    if (root.getAttribute("data-nackt-forms-teaser-positioned") !== "true") {
      formsTeaserRootStyleState = captureInlineStyleState(root, [
        "position",
        "top",
        "left",
        "right",
        "bottom",
        "width",
        "max-width",
        "height",
        "padding",
        "transform",
        "background-color",
        "z-index",
        "visibility",
        "opacity",
        "pointer-events"
      ]);
      formsTeaserButtonStyleState = captureInlineStyleState(teaserButton, [
        "max-width",
        "margin",
        "visibility",
        "opacity",
        "pointer-events"
      ]);
      root.setAttribute("data-nackt-forms-teaser-positioned", "true");
    }

    topOffset = Math.max(12, Math.round(getHeaderOffset() + 12));

    setImportantStyle(root, "position", "fixed");
    setImportantStyle(root, "top", topOffset + "px");
    setImportantStyle(root, "left", "1rem");
    setImportantStyle(root, "right", "auto");
    setImportantStyle(root, "bottom", "auto");
    setImportantStyle(root, "width", "auto");
    setImportantStyle(root, "max-width", "calc(100vw - 2rem)");
    setImportantStyle(root, "padding", "0");
    setImportantStyle(root, "transform", "none");
    setImportantStyle(root, "z-index", "2147483646");
    setImportantStyle(root, "visibility", "visible");
    setImportantStyle(root, "opacity", "1");
    setImportantStyle(root, "pointer-events", "auto");
    setImportantStyle(teaserButton, "max-width", "min(22rem, calc(100vw - 2rem))");
    setImportantStyle(teaserButton, "margin", "0");
    setImportantStyle(teaserButton, "visibility", "visible");
    setImportantStyle(teaserButton, "opacity", "1");
    setImportantStyle(teaserButton, "pointer-events", "auto");

    return true;
  }

  function reinforceFormsTeaserPosition() {
    var frameCount = 0;

    if (formsTeaserFrameSync) {
      window.cancelAnimationFrame(formsTeaserFrameSync);
    }

    function syncFrame() {
      var root = getFormsRoot();
      var didSync = syncFormsTeaserPosition(root);

      frameCount += 1;

      if (didSync && frameCount < 8) {
        formsTeaserFrameSync = window.requestAnimationFrame(syncFrame);
        return;
      }

      formsTeaserFrameSync = null;
    }

    formsTeaserFrameSync = window.requestAnimationFrame(syncFrame);
  }

  function scheduleFormsTeaserSync(delay) {
    if (formsTeaserScheduledSync) {
      window.clearTimeout(formsTeaserScheduledSync);
    }

    formsTeaserScheduledSync = window.setTimeout(function () {
      var root = getFormsRoot();

      if (syncFormsTeaserPosition(root)) {
        reinforceFormsTeaserPosition();
      }
      formsTeaserScheduledSync = null;
    }, typeof delay === "number" ? delay : 0);
  }

  function bindFormsTeaserRootObserver(root) {
    if (!window.MutationObserver || !root || formsTeaserObservedRoot === root) {
      return;
    }

    if (formsTeaserRootObserver) {
      formsTeaserRootObserver.disconnect();
    }

    formsTeaserObservedRoot = root;
    formsTeaserRootObserver = new window.MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        return mutation.type === "childList" || mutation.type === "attributes";
      });

      if (shouldSync) {
        scheduleFormsTeaserSync();
      }
    });

    formsTeaserRootObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-current-step", "data-position", "style", "class"]
    });
  }

  function initializeFormsTeaserObserver() {
    if (formsTeaserDocumentObserver || !window.MutationObserver) {
      return;
    }

    formsTeaserDocumentObserver = new window.MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        if (mutation.type === "childList") {
          return true;
        }

        return mutation.type === "attributes";
      });

      if (shouldSync) {
        bindFormsTeaserRootObserver(getFormsRoot());
        scheduleFormsTeaserSync();
      }
    });

    formsTeaserDocumentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-current-step", "data-position", "style", "class"]
    });

    bindFormsTeaserRootObserver(getFormsRoot());
    scheduleFormsTeaserSync();
    formsTeaserPolling = window.setInterval(function () {
      bindFormsTeaserRootObserver(getFormsRoot());
      scheduleFormsTeaserSync();
    }, 250);
    window.addEventListener("resize", scheduleFormsTeaserSync);
    window.addEventListener("orientationchange", scheduleFormsTeaserSync);
  }

  function isModifiedClick(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
  }

  function fetchLinkedColourwayDocument(targetUrl, signal) {
    var cacheKey = targetUrl.href;
    var cachedPromise = linkedColourwayDocumentCache.get(cacheKey);

    if (cachedPromise) {
      return cachedPromise;
    }

    cachedPromise = window.fetch(targetUrl.href, {
      credentials: "same-origin",
      signal: signal
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Failed to fetch colourway page");
      }

      return response.text();
    }).catch(function (error) {
      linkedColourwayDocumentCache.delete(cacheKey);
      throw error;
    });

    linkedColourwayDocumentCache.set(cacheKey, cachedPromise);
    return cachedPromise;
  }

  function parseLinkedColourwayDocument(htmlText) {
    return new window.DOMParser().parseFromString(htmlText, "text/html");
  }

  function resolveLinkedColourwayTargetHref(swatchLink) {
    var baseUrl = swatchLink.getAttribute("data-linked-base-url");
    var rawVariants = swatchLink.getAttribute("data-linked-variants");
    var rawDestinationOptionNames = swatchLink.getAttribute("data-linked-option-names");
    var variants;
    var destinationOptionNames;
    var currentOptions;
    var sourceOptionNames;

    if (!baseUrl || !rawVariants) {
      return swatchLink.href;
    }

    try {
      variants = JSON.parse(rawVariants);
    } catch (error) {
      return swatchLink.href;
    }

    try {
      destinationOptionNames = rawDestinationOptionNames ? JSON.parse(rawDestinationOptionNames) : [];
    } catch (error) {
      destinationOptionNames = [];
    }

    currentOptions = getCurrentSelectedOptions();
    sourceOptionNames = getCurrentProductOptionNames();

    return window.nacktEditorial.resolveLinkedProductUrl(
      baseUrl,
      variants,
      destinationOptionNames,
      sourceOptionNames,
      currentOptions.option1,
      currentOptions.option2,
      currentOptions.option3
    );
  }

  function getIncomingProductRoot(doc) {
    return doc.querySelector(".nackt-product-page[data-product-root]");
  }

  function updateDocumentMetadataFromIncomingDoc(doc, targetUrl) {
    var canonicalLink = document.querySelector('link[rel="canonical"]');
    var incomingCanonicalLink = doc.querySelector('link[rel="canonical"]');

    if (doc.title) {
      document.title = doc.title;
    }

    if (canonicalLink && incomingCanonicalLink) {
      canonicalLink.href = incomingCanonicalLink.href;
    } else if (canonicalLink) {
      canonicalLink.href = targetUrl.href;
    }
  }

  function reinitializeDynamicCheckoutButtons() {
    if (
      !window.Shopify
      || !window.Shopify.PaymentButton
      || typeof window.Shopify.PaymentButton.init !== "function"
    ) {
      return;
    }

    window.requestAnimationFrame(function () {
      window.Shopify.PaymentButton.init();
    });
  }

  function getCurrentVariantAvailableState(productRoot) {
    var availabilityAttribute;
    var addToCartButton;
    var addToCartText;

    if (!productRoot) {
      return null;
    }

    availabilityAttribute = productRoot.getAttribute("data-current-variant-available");

    if (availabilityAttribute === "true") {
      return true;
    }

    if (availabilityAttribute === "false") {
      return false;
    }

    addToCartButton = productRoot.querySelector(".add-to-cart");

    if (!addToCartButton) {
      return null;
    }

    addToCartText = (addToCartButton.textContent || "").toLowerCase();

    if (addToCartText.indexOf("sold out") !== -1 || addToCartButton.disabled) {
      return false;
    }

    return true;
  }

  function getCurrentVariantIdFromProductRoot(productRoot) {
    var variantInput;

    if (!productRoot) {
      return null;
    }

    variantInput = productRoot.querySelector("[data-current-variant-id-input], form.shopify-product-form input[name='id'], form.shopify-product-form select[name='id']");

    return variantInput ? variantInput.value : null;
  }

  function resetRestockRocketRefresh() {
    if (restockRocketRefreshTimer) {
      window.clearTimeout(restockRocketRefreshTimer);
      restockRocketRefreshTimer = null;
    }

    restockRocketRefreshVariantId = null;
    restockRocketRefreshAttempts = 0;
  }

  function dispatchRestockRocketVariantRefresh(productRoot, variantId) {
    var productForm;

    if (!productRoot || !variantId) {
      return;
    }

    if (
      window._RestockRocket
      && typeof window._RestockRocket.renderButtonForVariant === "function"
    ) {
      window._RestockRocket.renderButtonForVariant(variantId);
      return;
    }

    productForm = productRoot.querySelector("form.shopify-product-form");

    if (!productForm) {
      return;
    }

    productForm.querySelectorAll("[name='id']").forEach(function (variantInput) {
      if (variantInput.tagName === "SELECT") {
        Array.from(variantInput.options).forEach(function (option) {
          option.selected = option.value === String(variantId);
        });
      } else {
        variantInput.value = variantId;
      }

      variantInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function scheduleRestockRocketRefresh(productRoot) {
    var currentVariantId = getCurrentVariantIdFromProductRoot(productRoot);
    var refreshDelay;

    if (!currentVariantId) {
      return;
    }

    if (restockRocketRefreshVariantId !== currentVariantId) {
      resetRestockRocketRefresh();
      restockRocketRefreshVariantId = currentVariantId;
    }

    if (restockRocketRefreshTimer || restockRocketRefreshAttempts >= restockRocketRefreshDelays.length) {
      return;
    }

    refreshDelay = restockRocketRefreshDelays[restockRocketRefreshAttempts];
    restockRocketRefreshAttempts += 1;
    restockRocketRefreshTimer = window.setTimeout(function () {
      var latestProductRoot = getCurrentProductRoot();
      var latestVariantId = getCurrentVariantIdFromProductRoot(latestProductRoot);

      restockRocketRefreshTimer = null;

      if (
        !latestProductRoot
        || latestVariantId !== currentVariantId
        || getCurrentVariantAvailableState(latestProductRoot) === true
        || document.getElementById("restock-rocket-inline-container")
      ) {
        return;
      }

      dispatchRestockRocketVariantRefresh(latestProductRoot, latestVariantId);
      window.setTimeout(scheduleRestockRocketPlacement, 120);
    }, refreshDelay);
  }

  function syncCompactRestockButtonState(restockContainer) {
    var emailInput;
    var restockButton;
    var emailIsValid;

    if (!restockContainer) {
      return;
    }

    emailInput = restockContainer.querySelector("#form-Email");
    restockButton = restockContainer.querySelector("#form-Button");

    if (!emailInput || !restockButton) {
      return;
    }

    emailIsValid = emailInput.value.trim() !== "" && emailInput.checkValidity();
    restockButton.disabled = !emailIsValid;
    restockButton.setAttribute("aria-disabled", emailIsValid ? "false" : "true");
    restockButton.setAttribute("data-nackt-compact-validation", "true");
  }

  function initializeCompactRestockButtonValidation(restockContainer) {
    var emailInput;

    if (!restockContainer) {
      return;
    }

    emailInput = restockContainer.querySelector("#form-Email");

    if (!emailInput) {
      return;
    }

    if (!emailInput.__nacktCompactValidationBound) {
      emailInput.__nacktCompactValidationBound = true;
      ["input", "change", "blur"].forEach(function (eventName) {
        emailInput.addEventListener(eventName, function () {
          syncCompactRestockButtonState(restockContainer);
          window.requestAnimationFrame(function () {
            syncCompactRestockButtonState(restockContainer);
          });
        });
      });
    }

    syncCompactRestockButtonState(restockContainer);
  }

  function moveRestockRocketAboveCheckoutButtons() {
    var productRoot = getCurrentProductRoot();
    var restockContainer = document.getElementById("restock-rocket-inline-container");
    var addToCartContainer;
    var productForm;
    var stickyTray;
    var useCompactTray;
    var restockButton;
    var compactButtonLabel;

    if (!productRoot) {
      return;
    }

    stickyTray = productRoot.querySelector(".nackt-mobile-sticky-purchase-tray");
    useCompactTray = !!stickyTray;

    if (getCurrentVariantAvailableState(productRoot) === true) {
      if (restockContainer) {
        restockContainer.hidden = true;
        restockContainer.setAttribute("aria-hidden", "true");
        restockContainer.classList.add("nackt-restock-inline-container--hidden");
      }

      if (stickyTray) {
        stickyTray.classList.remove("nackt-mobile-sticky-purchase-tray--restock");
      }

      resetRestockRocketRefresh();
      return;
    }

    if (!restockContainer) {
      scheduleRestockRocketRefresh(productRoot);
      return;
    }

    addToCartContainer = productRoot.querySelector(".nackt-product-form__block--buy-buttons .add-to-cart-container, .nackt-product-form__block--buy_buttons .add-to-cart-container");

    if (!addToCartContainer) {
      return;
    }

    productForm = addToCartContainer.closest("form");

    if (!productForm) {
      return;
    }

    if (useCompactTray) {
      if (restockContainer.parentNode !== stickyTray || restockContainer.nextElementSibling !== addToCartContainer) {
        stickyTray.insertBefore(restockContainer, addToCartContainer);
      }

      stickyTray.classList.add("nackt-mobile-sticky-purchase-tray--restock");
      restockContainer.classList.add("nackt-restock-inline-container--compact");

      restockButton = restockContainer.querySelector("#form-Button");
      if (restockButton) {
        compactButtonLabel = stickyTray.getAttribute("data-nackt-restock-remind-label") + " \u2192";
        if (restockButton.textContent !== compactButtonLabel) {
          restockButton.textContent = compactButtonLabel;
        }
      }

      initializeCompactRestockButtonValidation(restockContainer);
    }

    restockContainer.hidden = false;
    restockContainer.removeAttribute("aria-hidden");
    restockContainer.classList.add("nackt-restock-inline-container");
    restockContainer.classList.remove("nackt-restock-inline-container--hidden");
    resetRestockRocketRefresh();
  }

  function scheduleRestockRocketPlacement() {
    if (restockRocketPlacementFrame) {
      return;
    }

    restockRocketPlacementFrame = window.requestAnimationFrame(function () {
      restockRocketPlacementFrame = null;
      moveRestockRocketAboveCheckoutButtons();
    });
  }

  function initializeRestockRocketPlacement() {
    if (restockRocketPlacementObserver) {
      return;
    }

    restockRocketPlacementObserver = new MutationObserver(scheduleRestockRocketPlacement);
    restockRocketPlacementObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    document.addEventListener("variant:change", scheduleRestockRocketPlacement);
    document.addEventListener("theme:variant:change", scheduleRestockRocketPlacement);
    window.addEventListener("load", scheduleRestockRocketPlacement);
    window.addEventListener("resize", scheduleRestockRocketPlacement);
    scheduleRestockRocketPlacement();
  }

  function replaceProductRoot(incomingProductRoot, currentScrollY) {
    var currentProductRoot = getCurrentProductRoot();

    if (!currentProductRoot || !incomingProductRoot) {
      return;
    }

    incomingProductRoot.setAttribute("on", "load");
    currentProductRoot.replaceWith(incomingProductRoot);
    initializeSizeSystemPickers(incomingProductRoot);
    reinitializeDynamicCheckoutButtons();
    window.scrollTo(0, currentScrollY);
    scheduleDesktopPdpPinSync();
    scheduleMobileContextualImageSync();
    window.requestAnimationFrame(function () {
      window.scrollTo(0, currentScrollY);
      scheduleDesktopPdpPinSync();
      scheduleMobileContextualImageSync();
    });
  }

  function fallbackToFullNavigation(targetUrl) {
    window.location.assign(targetUrl.href);
  }

  function hasRestockRocketProductApp() {
    return !!document.querySelector(
      "#RestockRocketConfig, #restock-rocket-inline-container, script[src*='restockrocket']"
    );
  }

  function swapLinkedColourwayProduct(targetHref, options) {
    var settings = options || {};
    var targetUrl;
    var currentScrollY = window.scrollY;
    var historyMode = settings.historyMode || "push";
    var swapNonce;

    try {
      targetUrl = new URL(targetHref, window.location.origin);
    } catch (error) {
      return Promise.reject(error);
    }

    if (linkedColourwaySwapController) {
      linkedColourwaySwapController.abort();
    }

    linkedColourwaySwapController = new window.AbortController();
    linkedColourwaySwapNonce += 1;
    swapNonce = linkedColourwaySwapNonce;

    return fetchLinkedColourwayDocument(targetUrl, linkedColourwaySwapController.signal).then(function (htmlText) {
      var incomingDoc;
      var incomingProductRoot;

      if (swapNonce !== linkedColourwaySwapNonce) {
        return;
      }

      incomingDoc = parseLinkedColourwayDocument(htmlText);
      incomingProductRoot = getIncomingProductRoot(incomingDoc);

      if (!incomingProductRoot) {
        fallbackToFullNavigation(targetUrl);
        return;
      }

      if (historyMode === "push") {
        window.history.pushState({ nacktLinkedColourwaySwap: true }, "", targetUrl.href);
      } else if (historyMode === "replace") {
        window.history.replaceState({ nacktLinkedColourwaySwap: true }, "", targetUrl.href);
      }

      clearLinkedColourwayScroll();
      updateDocumentMetadataFromIncomingDoc(incomingDoc, targetUrl);
      replaceProductRoot(incomingProductRoot, currentScrollY);
    }).catch(function (error) {
      if (error && error.name === "AbortError") {
        return;
      }

      fallbackToFullNavigation(targetUrl);
    }).finally(function () {
      if (swapNonce === linkedColourwaySwapNonce) {
        linkedColourwaySwapController = null;
      }
    });
  }

  window.nacktEditorial.resolveLinkedProductUrl = function resolveLinkedProductUrl(
    baseUrl,
    variants,
    destinationOptionNames,
    sourceOptionNames,
    option1,
    option2,
    option3
  ) {
    var variantList = Array.isArray(variants) ? variants : [];
    var currentOptions = [option1 || null, option2 || null, option3 || null];
    var sourceSizeIndex = getSizeOptionIndex(sourceOptionNames);
    var destinationSizeIndex = getSizeOptionIndex(destinationOptionNames);
    var selectedSize = sourceSizeIndex >= 0 ? currentOptions[sourceSizeIndex] : null;
    var sizeMatchAvailable = null;
    var sizeMatch = null;
    var exactMatch = variantList.find(function (variant) {
      return variant.option1 === currentOptions[0]
        && variant.option2 === currentOptions[1]
        && variant.option3 === currentOptions[2]
        && variant.available;
    });
    var fallbackExactMatch = variantList.find(function (variant) {
      return variant.option1 === currentOptions[0]
        && variant.option2 === currentOptions[1]
        && variant.option3 === currentOptions[2];
    });
    var fallbackAvailable = variantList.find(function (variant) {
      return variant.available;
    });

    if (selectedSize && destinationSizeIndex >= 0) {
      sizeMatchAvailable = variantList.find(function (variant) {
        return variant["option" + (destinationSizeIndex + 1)] === selectedSize && variant.available;
      });
      sizeMatch = variantList.find(function (variant) {
        return variant["option" + (destinationSizeIndex + 1)] === selectedSize;
      });
    }

    var targetVariant = sizeMatchAvailable || sizeMatch || exactMatch || fallbackExactMatch || fallbackAvailable || variantList[0];

    if (!targetVariant || !targetVariant.id) {
      return baseUrl;
    }

    try {
      var url = new URL(baseUrl, window.location.origin);
      url.searchParams.set("variant", targetVariant.id);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return baseUrl + (baseUrl.indexOf("?") === -1 ? "?" : "&") + "variant=" + targetVariant.id;
    }
  };

  document.addEventListener("click", function (event) {
    var swatchLink = event.target.closest(".nackt-linked-colourways__swatch");
    var targetHref;
    var targetUrl;

    if (!swatchLink || event.defaultPrevented) {
      return;
    }

    if (isModifiedClick(event) || swatchLink.target === "_blank") {
      return;
    }

    targetHref = resolveLinkedColourwayTargetHref(swatchLink);

    try {
      targetUrl = new URL(targetHref, window.location.origin);
    } catch (error) {
      return;
    }

    if (targetUrl.pathname === getCurrentProductPath()) {
      return;
    }

    if (hasRestockRocketProductApp()) {
      saveLinkedColourwayScroll(targetHref);
      saveLinkedColourwayMedia(targetHref);
      return;
    }

    event.preventDefault();
    saveLinkedColourwayScroll(targetHref);
    saveLinkedColourwayMedia(targetHref);
    swapLinkedColourwayProduct(targetHref);
  });

  window.addEventListener("popstate", function () {
    var currentProductRoot = getCurrentProductRoot();

    if (!currentProductRoot) {
      return;
    }

    if (window.location.pathname === getCurrentProductPath()) {
      return;
    }

    swapLinkedColourwayProduct(window.location.href, { historyMode: "replace" });
  });

  window.addEventListener("scroll", scheduleDesktopPdpPinSync, { passive: true });
  window.addEventListener("resize", scheduleDesktopPdpPinSync);
  window.addEventListener("resize", scheduleMobileContextualImageSync);
  window.addEventListener("orientationchange", scheduleDesktopPdpPinSync);
  window.addEventListener("orientationchange", scheduleMobileContextualImageSync);
  window.addEventListener("load", scheduleDesktopPdpPinSync);
  window.addEventListener("load", scheduleMobileContextualImageSync);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", scheduleMobileContextualImageSync);
  }
  window.addEventListener("load", function () {
    initializeSizeSystemPickers(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initializeSizeSystemPickers(event.target);
    scheduleMobileContextualImageSync();
  });

  document.addEventListener("theme:variant:change", function (event) {
    var productRoot = event.detail && event.detail.productRootEl ? event.detail.productRootEl : document;

    productRoot.querySelectorAll("[data-nackt-size-picker]").forEach(function (sizePicker) {
      updateSizePickerCurrentLabel(
        sizePicker,
        normalizeSizeSystem(sizePicker.getAttribute("data-nackt-size-system"))
          || getPreferredSizeSystem(sizePicker.getAttribute("data-nackt-size-default-system"))
      );
    });

    scheduleMobileContextualImageSync();
  });

  restoreLinkedColourwayScroll();
  initializeSizeSystemPickers(document);
  scheduleDesktopPdpPinSync();
  scheduleMobileContextualImageSync();
  initializeRestockRocketPlacement();
  initializeFormsTeaserObserver();
})();
